import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import ProcessButtons, {
  IProcessButton,
} from '../ProcessButtons/ProcessButtons';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';

export interface IProcessWarning {
  database: string;
  process: string;
  subProcess: string;
  activityFlow: string;
  activity: number;
  message: string;
}

interface IProps {
  content: IProcessButton[];
  subtitle?: string;
  selected?: IProcessButton;
  onSelect: (select: IProcessButton) => void;
  backgroundColor: 'medium' | 'light';
  truncated?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  header: {
    margin: 0,
  },
  mediumHeader: {
    backgroundColor: theme.customProperties.ProcessColors.processMediumHeaderBg,
    color: theme.customProperties.Fade.LightOnDark.highEmphasis,
  },
  lightHeader: {
    backgroundColor: theme.customProperties.ProcessColors.processLightHeaderBg,
    color: theme.customProperties.Fade.DarkOnLight.mediumEmphasis,
  },
  container: {
    display: 'flex',
    flex: '1 1 0%',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  containerTruncated: {
    height: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
  },
  containerActive: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  containerInactive: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  headerTextActive: {
    color: 'inherit',
  },
});

/**
 * Baskomponent för under headers i processvyn
 */
export const ProcessHeaderBase: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => {
  const { selected, content, classes, onSelect } = props;
  let backgroundColorClass;
  switch (props.backgroundColor) {
    case 'medium':
      backgroundColorClass = classes.mediumHeader;
      break;
    case 'light':
      backgroundColorClass = classes.lightHeader;
      break;
  }

  const activeContainerStyle = !selected
    ? classes.containerActive
    : classes.containerInactive;

  if (props.truncated) {
    return (
      <div
        className={classNames(
          classes.container,
          classes.containerTruncated,
          backgroundColorClass
        )}
      />
    );
  }

  return (
    <div
      className={classNames(
        classes.header,
        backgroundColorClass,
        activeContainerStyle
      )}
    >
      {!selected && (
        <ProcessButtons
          content={content}
          selected={selected}
          onSelect={onSelect}
          buttonSize="large"
          fullLabels={true}
        />
      )}
      {selected && (
        <div className={classNames(classes.container)}>
          <EDTypography variant="h5" className={classes.headerTextActive}>
            {`${selected.Kod} ${selected.Benamning}`}
          </EDTypography>
          <ProcessButtons
            content={content}
            selected={selected}
            onSelect={onSelect}
            buttonSize="medium"
          />
        </div>
      )}
    </div>
  );
};

export default withStyles(ProcessHeaderBase, styles);
